<template>
    <section class="section a-section a-section--fullheight">
        <div class="container" v-if="advice">
            <div class="columns is-mobile">
                <div class="column">
                    <p class="a-label">Data załadunku</p>
                    <div class="a-flex a-flex--justifyContent-flexStart">
                        <icon-calendar class="a-icon--marginRight"/>
                        <div>
                            <p class="a-text a-text--title">
                                {{ loadingDate }}
                            </p>
                            <p class="a-text">
                                {{ advice.loading_hours }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="columns is-mobile">
                <div class="column">
                    <p class="a-label">Data dostawy</p>
                    <div class="a-flex a-flex--justifyContent-flexStart">
                        <icon-calendar class="a-icon--marginRight"/>
                        <div>
                            <p class="a-text a-text--title">
                                {{ adviceDate }}
                            </p>
                            <p class="a-text">
                                {{ advice.hours }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="columns is-mobile">
                <div class="column">
                    <p class="a-label">Tonaż</p>
                    <p class="a-text a-text--title a-flex a-flex--justifyContent-flexStart">
                        <icon-tonnage class="a-icon--marginRight"/>
                        {{ advice.tonnage }} t
                    </p>
                </div>
                <div class="column">
                    <p class="a-label">Nr Zlecenia</p>
                    <p class="a-text a-text--title">
                        {{ advice.ax_id }}
                    </p>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <p class="a-label">Produkt</p>
                    <p class="a-text a-text--title a-text--marginBottom">
                        {{ advice.product }}
                    </p>
                    <p class="a-text">
                        {{ advice.suppliers.name }}
                    </p>
                    <br />
                    <button
                        class="button is-primary a-button a-button--main a-button--uppercase a-button--marginBottom a-flex"
                        @click="$router.push({ name: 'loading-photos', params: { token } })"
                    >
                        <icon-accept />
                        <span class="a-flex a-flex--flexDirection-column">
                            Towar załadowany
                            <small>Kliknij, aby potwierdzić</small>
                        </span>
                    </button>
                    <GmapMap
                        v-if="suppliersPosition"
                        class="a-map"
                        :center="suppliersPosition"
                        :zoom="10"
                        ref="gmap"
                        :options="{
                            disableDefaultUI: true
                        }"
                    >
                        <GmapMarker
                            :position="suppliersPosition"
                            :clickable="true"
                            :draggable="false"
                            @click="center = suppliersPosition"
                        />
                    </GmapMap>
                </div>
            </div>
            <div class="columns is-mobile">
                <div class="column">
                    <p class="a-text">
                        {{ advice.suppliers.name }}<br />
                        {{ advice.suppliers.address }}<br />
                        {{ advice.suppliers.postcode }}, {{ advice.suppliers.city }}<br />
                        <span v-if="advice.suppliers.phone">Tel. <a :href="`tel:${advice.suppliers.phone}`">{{ advice.suppliers.phone }}</a></span>
                    </p>
                </div>
                <div class="column">
                    <a
                        class="button a-button a-button--uppercase"
                        :href="`http://maps.apple.com/?daddr=${advice.suppliers.latitude},${advice.suppliers.longitude}`"
                    >
                        <icon-pin />
                        Zaplanuj trasę
                    </a>
                </div>
            </div>
            <button
                class="button a-button a-button--uppercase a-button--marginBottom"
                @click="$router.push({ name: 'unloading', params: { token }, query: { preview: true } })"
            >
                Zobacz dane rozładunku
            </button>
            <div class="columns">
                <div class="column">
                    <hr class="a-hr a-hr--noMargin" />
                    <p class="a-label">
                        Notatka / instrukcja
                    </p>
                    <p>
                        {{ advice.instructions }}
                    </p>
                    <p class="a-label">
                        Imię i nazwisko kierowcy
                    </p>
                    <p>
                        {{ advice.driver }}
                    </p>
                    <p class="a-label">
                        Numer rejestracyjny pojazdu i naczepy
                    </p>
                    <p>
                        {{ advice.registration }}
                    </p>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import IconCalendar from '@/components/icons/Calendar'
import IconAccept from '@/components/icons/Accept'
import IconTonnage from '@/components/icons/Tonnage'
import IconPin from '@/components/icons/Pin'

export default {
    name: 'Loading',
    components: {
        IconCalendar,
        IconAccept,
        IconTonnage,
        IconPin
    },
    computed: {
        advice() {
            return this.$store.getters.advice
        },
        token() {
            return this.$store.getters.token
        },
        adviceDate() {
            return this.$dayjs(this.advice.date).format('DD.MM.YYYY')
        },
        loadingDate() {
            return this.$dayjs(this.advice.loading_date).format('DD.MM.YYYY')
        },
        suppliersPosition() {
            return this.$store.getters.suppliersPosition
        }
    }
}
</script>
